import { TOKENS } from '../ui/dashboard-primitives'

/**
 * The raw failure, for a developer only. Callers gate this on
 * `showErrorDetail()`; this component never decides for itself, so there is one
 * place to read the policy rather than one per screen.
 *
 * A RECESSED SURFACE, per DESIGN.md's two families: this is something you look
 * INTO, not something you act on. `TOKENS.warmDark` rather than a new literal,
 * and at its full opacity on purpose, because a stack trace is the one thing on
 * this screen that needs contrast over the page gradient rather than to blend
 * into it.
 *
 * The stack scrolls inside its own box. A long trace must never make the page
 * itself scroll sideways.
 */
export function ErrorDetail({ error }: { error: unknown }) {
  const name = error instanceof Error ? error.name : 'Error'
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : String(error)
  const stack = error instanceof Error ? error.stack : undefined

  return (
    <div className="mt-10 text-left">
      <div
        className="text-[9px] uppercase tracking-[0.26em]"
        style={{ fontFamily: 'var(--font-mono)', color: TOKENS.creamDim }}
      >
        Developer detail
      </div>
      <div
        className="mt-2.5 rounded-xl px-4 py-3.5"
        style={{
          background: TOKENS.warmDark,
          boxShadow: 'inset 0 0 0 1px var(--text-cream-border)',
        }}
      >
        <p
          className="text-[12px] leading-relaxed break-words"
          style={{ fontFamily: 'var(--font-mono)', color: TOKENS.terracotta }}
        >
          {name}: {message}
        </p>
        {stack && (
          <pre
            className="mt-3 max-h-64 overflow-auto text-[11px] leading-relaxed whitespace-pre"
            style={{ fontFamily: 'var(--font-mono)', color: TOKENS.creamDim }}
          >
            {stack}
          </pre>
        )}
      </div>
    </div>
  )
}
